<template>
  <!-- <div class="w contact f-c-c"> -->

    <div v-if="isPC">
      <div class="w contact">
      <div class="f-b">
      <div class="contact-info" style="width: 50%;">
        <h2 class="info-title">{{ $t('Home.terms.ContactUs.ContactInfo') }}</h2>
        <div class="address-info">
          <span> <i class="iconfont icon-map-pin-2-line" style="display:inline-block;margin-right:2px;font-size: 16px;"></i> {{ $t('Home.terms.ContactUs.LosAngeles') }}</span>
          <p>{{ $t('Home.terms.ContactUs.Tips1') }} </p>
        </div>
        <div class="address-info">
          <span> <i class="iconfont icon-map-pin-2-line" style="display:inline-block;margin-right:2px;font-size: 16px;"></i> {{ $t('Home.terms.ContactUs.NewYork') }}</span>
          <p>{{ $t('Home.terms.ContactUs.Tips2') }}</p>
        </div>
        <div class="address-info">
          <span> <i class="iconfont icon-map-pin-2-line" style="display:inline-block;margin-right:2px;font-size: 16px;"></i>{{ $t('Home.terms.ContactUs.HongKong') }} </span>
          <p> {{ $t('Home.terms.ContactUs.Tips3') }}</p>
        </div>
        <div class="address-info">
          <span> <i class="iconfont icon-map-pin-2-line" style="display:inline-block;margin-right:2px;font-size: 16px;"></i>{{ $t('Home.terms.ContactUs.Shenzhen') }} </span>
          <p> {{ $t('Home.terms.ContactUs.Tips4') }}</p>
        </div>
        <div class="address-info">
          <span> <i class="iconfont icon-map-pin-2-line" style="display:inline-block;margin-right:2px;font-size: 16px;"></i> {{ $t('Home.terms.ContactUs.DongGuan') }} </span>
          <p>{{ $t('Home.terms.ContactUs.Tips5') }} </p>
        </div>
        <div>
          <p class="associate-box">
            <a href="https://www.facebook.com/KakaClo-Dropshipping-112237164586153" target="_blank"><img src="@/assets/img/homePage/facebook_b.svg" alt="" lazy /></a>
            <a href="https://www.instagram.com/KakaClodropshipping/" target="_blank"><img src="@/assets/img/homePage/ins_b.svg" alt="" lazy /></a>
            <a href="https://www.youtube.com/channel/UCEnAXbQRPJcK7vyakzYxX-g/featured" target="_blank"><img src="@/assets/img/homePage/youtube_b.svg" alt="" lazy /></a>
            <a href="https://twitter.com/DKakaClo" target="_blank"><img src="@/assets/img/homePage/twitter_b.svg" alt="" lazy /></a>
            <el-popover placement="top" trigger="hover" content="">
              <p style="font-size:20px;font-weight:600;text-align:center;color: #121e26;">{{ $t('Home.terms.ContactUs.KakaCloSupport') }}</p>
              <p style="font-size:14px;text-align:center">{{ $t('Home.terms.ContactUs.WathsAppContact') }}</p>
              <oss-img src="https://img.kakaclo.com/web-img/whatsAPP.png" alt="" :width="90" :height="90" style="width:100%"></oss-img>
              <a href="javascript:void(0);" slot="reference" target="_blank"><img src="@/assets/img/homePage/WhatsApp_b.svg" alt="" lazy /></a>
            </el-popover>
          </p>
        </div>
      </div>

      <div class="collect-info" style="width: 50%;">
        <h2 class="info-title">{{ $t('Home.terms.ContactUs.ContactUs') }}</h2>
        <div class="com-info">
          <p>{{ $t('Home.terms.ContactUs.Email') }}: info@kakaclo.com</p>
          <p>{{ $t('Home.terms.ContactUs.Phone') }}: +1 626 866 2112,+1 507 889 1806  </p>
        </div>
        <div class="box">
          <el-form label-position="top" label-width="80px" :model="userForm" :rules="rules" ref="userForm" @submit.native.prevent>
            <el-form-item :label="$t('Home.terms.ContactUs.YourName')" prop="customerName">
              <el-input v-model.trim="userForm.customerName"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Home.terms.ContactUs.Email')" prop="email">
              <el-input v-model.trim="userForm.email" ></el-input>
            </el-form-item>
            <el-form-item :label="$t('Home.terms.ContactUs.Message')" prop="feedbackContent">
              <el-input type="textarea" resize="none" :rows="4" style="border-radius:8px;" v-model="userForm.feedbackContent">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="success" style="width:100%;border-radius:8px;margin-top:15px;background-color: #99c41c;" @click="putCustomerFeedback">{{ $t('Home.terms.ContactUs.Send') }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    </div>
    </div>
    <div v-else>
      <div class="w contact" style="padding: 60px 30px;">
      <div class="collect-info">
        <h2 class="info-title">{{ $t('Home.terms.ContactUs.ContactUs') }}</h2>
        <div class="com-info">
          <p>{{ $t('Home.terms.ContactUs.Email') }}: info@kakaclo.com</p>
          <p>{{ $t('Home.terms.ContactUs.Phone') }}: +1 626 866 2112,+1 507 889 1806  </p>
        </div>
        <div class="box">
          <el-form label-position="top" label-width="80px" :model="userForm" :rules="rules" ref="userForm" @submit.native.prevent>
            <el-form-item :label="$t('Home.terms.ContactUs.YourName')" prop="customerName">
              <el-input v-model.trim="userForm.customerName"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Home.terms.ContactUs.Email')" prop="email">
              <el-input v-model.trim="userForm.email" ></el-input>
            </el-form-item>
            <el-form-item :label="$t('Home.terms.ContactUs.Message')" prop="feedbackContent">
              <el-input type="textarea" resize="none" :rows="4" style="border-radius:8px;" v-model="userForm.feedbackContent">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="success" style="width:100%;border-radius:8px;margin-top:15px;background-color: #99c41c;" @click="putCustomerFeedback">{{ $t('Home.terms.ContactUs.Send') }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="contact-info" style="margin-right: 5px;">
        <h2 class="info-title moblie">{{ $t('Home.terms.ContactUs.ContactInfo') }}</h2>

        <div class="address-info">
          <span> <i class="iconfont icon-map-pin-2-line" style="display:inline-block;margin-right:2px;font-size: 16px;"></i> {{ $t('Home.terms.ContactUs.LosAngeles') }}</span>
          <p>{{ $t('Home.terms.ContactUs.Tips1') }} </p>
        </div>
        <div class="address-info">
          <span> <i class="iconfont icon-map-pin-2-line" style="display:inline-block;margin-right:2px;font-size: 16px;"></i> {{ $t('Home.terms.ContactUs.NewYork') }}</span>
          <p>{{ $t('Home.terms.ContactUs.Tips2') }}</p>
        </div>
        <div class="address-info">
          <span> <i class="iconfont icon-map-pin-2-line" style="display:inline-block;margin-right:2px;font-size: 16px;"></i>{{ $t('Home.terms.ContactUs.HongKong') }} </span>
          <p> {{ $t('Home.terms.ContactUs.Tips3') }}</p>
        </div>
        <div class="address-info">
          <span> <i class="iconfont icon-map-pin-2-line" style="display:inline-block;margin-right:2px;font-size: 16px;"></i>{{ $t('Home.terms.ContactUs.Shenzhen') }} </span>
          <p> {{ $t('Home.terms.ContactUs.Tips4') }}</p>
        </div>
        <div class="address-info">
          <span> <i class="iconfont icon-map-pin-2-line" style="display:inline-block;margin-right:2px;font-size: 16px;"></i> {{ $t('Home.terms.ContactUs.DongGuan') }} </span>
          <p>{{ $t('Home.terms.ContactUs.Tips5') }} </p>
        </div>
        <div>
          <p class="associate-box">
            <a href="https://www.facebook.com/KakaClo-Dropshipping-112237164586153" target="_blank"><img src="@/assets/img/homePage/facebook_b.svg" alt="" lazy /></a>
            <a href="https://www.instagram.com/KakaClodropshipping/" target="_blank"><img src="@/assets/img/homePage/ins_b.svg" alt="" lazy /></a>
            <a href="https://www.youtube.com/channel/UCEnAXbQRPJcK7vyakzYxX-g/featured" target="_blank"><img src="@/assets/img/homePage/youtube_b.svg" alt="" lazy /></a>
            <a href="https://twitter.com/DKakaClo" target="_blank"><img src="@/assets/img/homePage/twitter_b.svg" alt="" lazy /></a>
            <el-popover placement="top" trigger="hover" content="">
              <p style="font-size:20px;font-weight:600;text-align:center;color: #121e26;">{{ $t('Home.terms.ContactUs.KakaCloSupport') }}</p>
              <p style="font-size:14px;text-align:center">{{ $t('Home.terms.ContactUs.WathsAppContact') }}</p>
              <oss-img src="https://img.kakaclo.com/web-img/whatsAPP.png" alt="" :width="90" :height="90" style="width:100%"></oss-img>
              <a href="javascript:void(0);" slot="reference" target="_blank"><img src="@/assets/img/homePage/WhatsApp_b.svg" alt="" lazy /></a>
            </el-popover>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import OssImg from '../../../components/OssImg.vue'
import { checkEmail } from '@/util/validate'
let validateEmail = (rule, value, callback) => {
  if (checkEmail(value)) {
    callback()
  } else {
    callback(new Error(`${this.$t('Home.terms.ContactUs.Tips6')}`))
  }
}
export default {
  metaInfo: {
    title: 'Contact Us - KakaClo',
    meta: [
      {
        name: 'description',
        content: 'KakaClo is the industry-leading apparel supply chain platform that focuses on providing customers with in stock apparel custom production and dropshipping service.'
      }
    ]
  },
  components: { OssImg },
  data() {
    return {
      rules: {
        customerName: [{ required: true, message: `${this.$t('Home.terms.ContactUs.Tips7')}`, trigger: 'blur' }],
        feedbackContent: [{ required: true, message: `${this.$t('Home.terms.ContactUs.Tips8')}`, trigger: 'blur' }],
        email: [{ required: true, message: `${this.$t('Home.terms.ContactUs.Tips6')}`, trigger: 'blur' }, { validator: validateEmail, trigger: 'blur' }]
      },
      userForm: {}
    }
  },
  methods: {
    putCustomerFeedback() {
      this.$refs.userForm.validate(valid => {
        if (!valid) return
        API.putCustomerFeedback(this.userForm).then(res => {
          this.$message.success(`${this.$t('Home.terms.ContactUs.SubmitSuccess')}`)
          this.$refs.userForm.resetFields()
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../css/homeOld.scss';
.contact {
  color: #121e26;
  margin-top: 40px;
  margin-bottom: 40px;
  background: #fff;
  padding: 60px 75px;
}
.info-title {
  font-weight: 700;
  font-size: 36px;
  line-height: 60px;
  color: #2a3342;
}

.moblie {
  font-weight: bold;
  font-size: 24px;
  line-height: 60px;
  color: #303133;
}
.contact-info {
  margin-right: 65px;

  .address-info {
    // max-width: 300px;
    margin-bottom: 20px;
    span {
      display: inline-block;
      font-weight: 600;
      font-size: 16px;
      line-height: 21px;
      color: #121e26;
      margin-bottom: 3px;
    }
    p {
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: #333f51;
    }
  }
  div {
    margin-bottom: 20px;
  }
}
.collect-info {
  h6 {
    font-weight: 400;
    font-size: 18px;
    line-height: 30px;
    color: #556987;
    margin-bottom: 34px;
  }
  .com-info {
    margin: 0 0 20px 0;
    p {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #333f51;
      margin-bottom: 6px;
    }
  }
  .box {
    // width: 554px;
    padding: 23px 40px;
    background: #f7f8f9;
    box-shadow: 0px 1px 2px rgba(85, 105, 135, 0.1);
    border-radius: 6px;
  }
}
.associate-box {
  padding-top: 30px;
  a {
    margin: 0 5px;
    img {
      width: 22px;
    }
  }
}
/deep/.el-form-item__label {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #333f51;
  margin-bottom: 6px;
  padding: 0;
}
/deep/.el-input__inner {
  border-radius: 8px;
  height: 46px;
}
/deep/.el-form-item {
  margin-bottom: 11px;
}
</style>
